import { websitenotfoundModule } from "./websitenotfound/websitenotfound.module";
import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { AppComponent } from "./app.component";

// Import your library
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { StoreModule } from "@ngrx/store";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { SharedModule } from "./shared/shared.module";
import { LoaderInterceptor } from "./shared/helpers/loader.interceptor";
import { AuthGuard } from "./shared/helpers/auth.guard";
import { ErrorInterceptor } from "./shared/helpers/error.interceptor";
import { StoreDevtoolsModule } from "@ngrx/store-devtools";
import { environment } from "../environments/environment";
import { EffectsModule } from "@ngrx/effects";
import { ProductEffects } from "./store/effects/product.effects";
import { appReducers } from "./store/reducers/app.reducer";
import { common } from "./shared/helpers/helper.common";
import { MerchantEffects } from "./store/effects/merchant.effects";
import { CategoriesEffects } from "./store/effects/category.effects";
import { AppRoutingModule } from "./app-routing.module";
import { AuthModule } from "./auth/auth.module";
import {
  ServiceWorkerModule,
  SwRegistrationOptions,
} from "@angular/service-worker";
import { OnlineStatusComponent } from "./shared/commonComponent/online-status/online-status.component";
import { NewCategoryComponent } from "./new-category/new-category/new-category.component";
import { SubCategoriesEffects } from "./store/effects/sub-category.effects";
@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    HttpClientModule,
    NgbModule,
    AppRoutingModule,
    AuthModule,
    SharedModule,
    StoreModule.forRoot(appReducers, {
      // metaReducers,
      // runtimeChecks: {
      //   strictStateImmutability: true,
      //   strictActionImmutability: true,
      // }
    }),
    !environment.production
      ? StoreDevtoolsModule.instrument({ connectInZone: true })
      : [],
    EffectsModule.forRoot([
      ProductEffects,
      MerchantEffects,
      CategoriesEffects,
      SubCategoriesEffects,
    ]),
    StoreDevtoolsModule.instrument({
      maxAge: 25,
      logOnly: environment.production,
      connectInZone: true,
    }),
    ServiceWorkerModule.register("ngsw-worker.js"),
    OnlineStatusComponent,
  ],
  //providers: [],
  bootstrap: [AppComponent],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
    {
      provide: SwRegistrationOptions,
      useFactory: () => ({ enabled: environment.production }),
    },
    AuthGuard,
    ErrorInterceptor,
    common,
  ],
})
export class AppModule {}
